<div class="graph-dashboard">
  <div class="graph-dropdown">
    <select [(ngModel)]="selectedView">
      <option value="tech_only">Technologies View</option>
      <option value="domains_only">Domains View</option>
      <option value="team_only">Teams View</option>
    </select>
  </div>

  <div class="graph-container">
    <app-whole-view *ngIf="selectedView === 'whole_graph'" [fullGraphData]="fullGraphData"></app-whole-view>

    <app-technologies-view
      *ngIf="selectedView === 'tech_only'"
      [fullGraphData]="fullGraphData"
      (statsChanged)="onStatsChanged($event)"
    ></app-technologies-view>

    <app-domains-view
      *ngIf="selectedView === 'domains_only'"
      [fullGraphData]="fullGraphData"
      (statsChanged)="onStatsChanged($event)"
    ></app-domains-view>

    <app-teams-view
      *ngIf="selectedView === 'team_only'"
      [fullGraphData]="fullGraphData"
      (statsChanged)="onStatsChanged($event)"
    ></app-teams-view>
  </div>
</div>

<div class="stats-bar">
  <div class="stat-item">
    <h2>{{ projectStats.totalProjects }}</h2>
    <p>Total Projects</p>
  </div>
  <div class="stat-item">
    <h2>{{ projectStats.mainConcepts }}</h2>
    <p>Technology Categories</p>
  </div>
  <div class="stat-item">
    <h2>{{ projectStats.subConcepts }}</h2>
    <p>Sub-Concepts</p>
  </div>
  <div class="stat-item">
    <h2>{{ projectStats.domains }}</h2>
    <p>Domains</p>
  </div>
  <div class="stat-item">
    <h2>{{ projectStats.contributors }}</h2>
    <p>Contributors</p>
  </div>
</div>
